<template>
  <div class="text_quiz">
    <div class="text_quiz__button" v-if="!start && !finish">
      <button class="uk-button uk-button-primary" @click="start = true">Ответить на вопросы по тексту</button>
    </div>
    <div class="text_quiz__body" v-if="start">
      <div class="text_quiz__subtitle">Вопросы по тексту:</div>
      <ul class="text_quiz__items">
        <li v-for="(item, key) in items" :key="item.id" class="text_quiz__item">
          <h4>{{ item.question }}</h4>
          <answers :items="item.answers" :answer="item.answer" :keys="key" @selectAnswer="selectAnswer($event, item)"></answers>
        </li>
      </ul>
      <div class="text_quitz__check">
        <button class="uk-button uk-button-primary" @click="checkResult">Проверить</button>
      </div>
    </div>
    <div class="text_quiz__quality" v-if="finish">
      <span>Правильные ответы: <strong>{{ stat }}</strong></span>
      <span>Процент понимания текста: <strong>{{ quality }}%</strong></span> 
    </div>
  </div>
</template>

<script>
import answers from "./answers";

export default {
  name: "quiz",
  components: {
    answers
  },
  data() {
    return {
      stat: '',
      start: false,
      finish: false,
      quality: ''
    }
  },
  props: {
    items: '',
    stats: ''
  },
  methods: {
    selectAnswer(event, item) {
      item['choosen'] = event;
      console.log(item)
    },
    checkResult() {
      let result = [];
      let n = 0;
      _.forEach(this.items, (i) => {
        result.push(i.choosen.status);
        n++;
      });
      console.log(n, result);
      let rs = _.filter(result, (i) => {
        return i;
      });

      this.stat = `${rs.length} из ${n}` 

      let quality = Math.floor((100 * (rs.length > 0 ? (rs.length / n) : 0)));
      this.finish = true;
      this.start = false;
      this.quality = quality;
      this.$emit('endQuestions', quality);
      console.log(quality);
      // Проверяем по массиву количество правильных ответов и вычисляем процент правильных и дальше выводим результат - понимание текста такое-то
    }
  },
  mounted() {
    this.$emit('hasQuestions');
  }
}
</script>

<style lang="scss" scoped>
.text_quiz__quality {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  & span {
    color: #666666;
    font-size: 18px;
    margin-bottom: 5px;
  }
}
</style>